import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ProductCard/ProductCard.tsx
import { shopifyImageSource } from "../../../../utils/shopifyImageSource.mjs";
import { Button } from "../../../primitive/Button/Button.mjs";
import { StableLabel } from "../../../primitive/Button/StableLabel.mjs";
import { DrawnCheck } from "../../../primitive/DrawnCheck/DrawnCheck.mjs";
import { ImageFrame } from "../../../primitive/ImageFrame/ImageFrame.mjs";
import { Text } from "../../../primitive/Text/Text.mjs";
import { resolveProductUrl } from "../ContentChips/productMentions.mjs";
import { AddToCartStatus } from "../shared/AddToCartStatus.mjs";
import { addToCartAriaLabel, useAddToCartState } from "../shared/useAddToCartState.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var SINGLE_IMAGE_PX = 160;
function ProductCard({ product, storeDomain, onAddToCart }) {
  const { t } = useTranslation();
  const { cartStateOf, addToCart, outcome } = useAddToCartState(onAddToCart);
  const cartState = cartStateOf(product.id);
  const productUrl = resolveProductUrl(product.url, storeDomain);
  const isLoading = cartState === "loading";
  const isAdded = cartState === "added";
  const addedLabel = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DrawnCheck, { drawn: isAdded }),
    t("product.added")
  ] });
  const isError = cartState === "error";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "buyscout-product-card-single", children: [
      /* @__PURE__ */ jsx(
        ImageFrame,
        {
          ...product.imageUrl ? shopifyImageSource(product.imageUrl, SINGLE_IMAGE_PX) : void 0,
          alt: "",
          fallback: "bag",
          loading: "lazy",
          className: "buyscout-product-card-single-image",
          imgClassName: "buyscout-product-card-single-image-img"
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "buyscout-product-card-single-info", children: [
        /* @__PURE__ */ jsx(Text, { variant: "body-bold", as: "h3", className: "buyscout-product-card-single-title", children: productUrl ? /* @__PURE__ */ jsx("a", { href: productUrl, target: "_blank", rel: "noopener noreferrer", className: "buyscout-product-card-single-link", children: product.title }) : product.title }),
        /* @__PURE__ */ jsx(Text, { variant: "body-bold", as: "span", className: "buyscout-product-card-single-price", children: product.price }),
        onAddToCart && /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            variant: "prominent",
            size: "sm",
            color: isAdded ? "success" : isError ? "error" : "primary",
            className: `buyscout-product-card-single-add-to-cart buyscout-add-to-cart ${cartState}`,
            "data-cart-state": cartState,
            onClick: () => {
              void addToCart(product);
            },
            loading: isLoading,
            "aria-disabled": isAdded || void 0,
            "aria-label": addToCartAriaLabel(t, cartState, product.title),
            children: /* @__PURE__ */ jsx(StableLabel, { labels: [t("product.addToCart"), addedLabel, t("product.failed")], children: isAdded ? addedLabel : isError ? t("product.failed") : t("product.addToCart") })
          }
        )
      ] })
    ] }),
    onAddToCart && /* @__PURE__ */ jsx(AddToCartStatus, { outcome, t })
  ] });
}
export {
  ProductCard
};
//# sourceMappingURL=ProductCard.mjs.map